// src/redux/sagas/tpnConfigSaga.ts
import { call, put, takeEvery } from 'redux-saga/effects';
import { request } from '../../api/request';
import ENDPOINTS from '../../api/endpoints';
import { parseApiResponse } from '../../utils/jsonParser';
import {
  fetchTpnConfigRequest,
  fetchTpnConfigSuccess,
  fetchTpnConfigFailure,
} from '../slices/tpnConfigSlice';
import { shouldSkipApiCalls } from '../../utils/appConfig';
import { TpnConfig } from '../../types/tpnConfig';

function* fetchTpnConfigSaga(): Generator<any, void, any> {
  // Skip API calls if in preview mode
  if (shouldSkipApiCalls()) {
    const emptyConfig: TpnConfig = { tpn_config: [] };
    yield put(fetchTpnConfigSuccess(emptyConfig));
    return;
  }

  try {
    const response = yield call(request, {
      method: 'GET',
      url: ENDPOINTS.GET_PAYMENT_INFO,
    });

    const parsedData = parseApiResponse<TpnConfig>(response.data);

    yield put(fetchTpnConfigSuccess(parsedData));
  } catch (error: any) {
    yield put(fetchTpnConfigFailure(error.message || 'Failed to fetch TPN config'));
  }
}

export function* watchTpnConfigSaga() {
  yield takeEvery(fetchTpnConfigRequest.type, fetchTpnConfigSaga);
}
